import { render, staticRenderFns } from "./PrescriptionRxItemInput.vue?vue&type=template&id=5ec1a2da"
import script from "./PrescriptionRxItemInput.vue?vue&type=script&lang=js"
export * from "./PrescriptionRxItemInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports